import store from '@/store';
import { getBuildedMatfileTemplate } from '@/helpers/matfile';

const MANDATORY_MATERIALS = [
  {
    name: 'PML-M100 (D100)R',
    articleNumber: '1014181',
  },
  {
    name: 'PML-M100 (D50)R',
    articleNumber: '1014180',
  },
  {
    name: 'US-PML-M100 (D100)',
    articleNumber: '1014177',
  },
  {
    name: 'US-PML-M100 (D50)',
    articleNumber: '1014176',
  },
];

export default () => {
  const { core: { colorSchema } } = store.getState();
  const matfileTemplate = getBuildedMatfileTemplate();

  return MANDATORY_MATERIALS.some(item => matfileTemplate?.name.includes(item.name) || `${colorSchema?.article_number || ''}` === item.articleNumber);
};
